<template>
  <div class="not-found-view">
    <NavBar />
    <NavIsland />
    <main class="content-wrapper">
      <div class="error-container ln-glass-elevated">
        <h1>404</h1>
        <h2>{{ $t('common.pageNotFound') }}</h2>
        <p>{{ $t('common.pageNotFoundDesc') }}</p>
        <button class="cta-primary" @click="$router.push({ name: 'home' })">
          <span class="mdi mdi-home"></span> {{ $t('common.backToHome') }}
        </button>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import NavBar from '@/component/common/NavBar.vue';
import NavIsland from '@/component/common/NavIsland.vue';
import { usePostHog } from '@/composables/usePostHog';

@Component({
  components: {
    NavBar,
    NavIsland
  }
})
export default class NotFoundView extends Vue {
  private posthog = usePostHog().posthog;

  mounted() {
    this.posthog.capture('404_page_viewed', {
      attempted_url: window.location.href,
      path: this.$route.path
    });
  }
}
</script>

<style scoped>
.not-found-view {
  min-height: calc(100vh - var(--ln-nav-offset));
  background-color: var(--ln-bg);
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.error-container {
  text-align: center;
  padding: 4rem;
  border-radius: var(--ln-radius-lg);
  max-width: 600px;
  width: 100%;
}

h1 {
  font-size: 6rem;
  color: var(--ln-teal-deep);
  margin-bottom: 1rem;
  line-height: 1;
}

h2 {
  font-size: 2rem;
  color: var(--ln-text-primary);
  margin-bottom: 1rem;
}

p {
  color: var(--ln-text-secondary);
  font-size: 1.1rem;
  margin-bottom: 2.5rem;
}

.cta-primary {
  background: var(--ln-teal-deep);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: var(--ln-radius-md);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all var(--ln-transition-normal) var(--ln-ease-smooth);
}

.cta-primary:hover {
  background: var(--ln-teal-light);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(44, 122, 123, 0.3);
}

.cta-primary span {
  font-size: 1.3rem;
}
</style>
